import type { RoolChannel } from '@rool-dev/sdk';
import { cursorTarget } from '../stores';
import { NODE_HEIGHT, NODE_WIDTH } from './constants';
import { rebuildGraph } from './graph';
import {
	cacheObject,
	mergeObjectCache,
	uncacheObject,
	loadAllObjects,
	markNodeLocallyModified,
	isNodeLocallyModified,
} from './canvas-object-store';

export function setupCanvasReconciler(openedChannel: RoolChannel): void {
	openedChannel.on('objectCreated', (event: any) => {
		if (event?.object) {
			cacheObject(event.object);
		}
		if (event?.source === 'local_user' && event?.objectId) {
			markNodeLocallyModified(event.objectId, 5000);
		}
		rebuildGraph();
	});

	openedChannel.on('objectUpdated', (event: any) => {
		if (event?.object) {
			if (event.source === 'local_user') {
				mergeObjectCache(event.objectId, event.object);
				return;
			}
			cacheObject(event.object);
		}

		if (event?.objectId && isNodeLocallyModified(event.objectId)) {
			return;
		}

		if (event?.objectId) {
			const obj = event.object ?? {};
			const objX = obj._x ?? obj.x;
			const objY = obj._y ?? obj.y;
			if (typeof objX === 'number' && typeof objY === 'number') {
				cursorTarget.set({
					x: objX + NODE_WIDTH / 2,
					y: objY + NODE_HEIGHT / 2,
					source: event.source,
				});
			}
		}

		rebuildGraph();
	});

	openedChannel.on('objectDeleted', (event: any) => {
		if (event?.objectId) {
			uncacheObject(event.objectId);
		}
		rebuildGraph();
	});

	openedChannel.on('reset', () => {
		loadAllObjects(openedChannel).then(() => rebuildGraph());
	});
}
